<template>
  <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="$store.state.user.currentPage" :page-sizes="myOption.pageSize.arr" :page-size="$store.state.user.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="$store.state.user.pageTotal"></el-pagination>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    getList: {
      type: Function,
      default: null
    }
  },
  methods: {
    // 设置每页条数
    handleSizeChange (val) {
      this.$store.dispatch('SetPageSize', val)
      this.getList()
    },
    // 设置页码
    handleCurrentChange (val) {
      this.$store.dispatch('SetCurrentPage', val)
      this.getList()
    }
  },
  beforeDestroy () {
    this.$store.dispatch('RestPage')
  }
}
</script>

<style>
  .el-pagination{
    text-align: right;
  }
  .el-pagination__total,.el-pagination__sizes{
    float: left;
  }
  /*.btn-prev,.el-pager,.btn-next,.el-pagination__jump{*/
  /*float: right;*/
  /*}*/
  .el-pagination__sizes,.el-pagination__sizes>.el-select,.el-pagination__sizes>.el-select>.el-input {
    font-size: 0!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue